// should be rmemoved once Export APIs are available

import { useCallback } from 'react';

import type {
  RiskExportRequest,
  RiskExportResponse,
} from './mutations/use-risk-exports';
import type {
  VulnerabilityExportRequest,
  VulnerabilityExportResponse,
} from './mutations/use-vulnerability-risks-export';

export const useRiskExportsMockApi = () => {
  const mockRiskExportApi = useCallback(
    (
      endpoint: string,
      params: RiskExportRequest,
    ): Promise<RiskExportResponse> => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            downloadURL: 'https://www.example.com/' + crypto.randomUUID(),
          });
        }, 500);
      });
    },
    [],
  );

  const mockVulnerabilityExport = useCallback(
    (
      endpoint: string,
      params: VulnerabilityExportRequest,
    ): Promise<VulnerabilityExportResponse> => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            downloadURL: 'https://www.example.com/' + crypto.randomUUID(),
          });
        }, 500);
      });
    },
    [],
  );

  return { mockRiskExportApi, mockVulnerabilityExport };
};
